module.exports = __webpack_public_path__ + "img/A58A1265_min.55b70fe5.jpg";